import React from "react";
import Card from "../../components/Card";
import { useAuth } from "../../apis/auth/AuthProvider";


const Home: React.FC = () => {
  // Perfil efetivo, e nao o real: com emulacao ligada os cards precisam ser os que o
  // perfil emulado veria - e isso muda sem recarregar a pagina, entao vem do contexto
  // em vez de uma leitura unica no mount.
  const { perfilEfetivo: userRole } = useAuth();

  return (
    <div className="container mt-3">
      {userRole === "ROLE_MASTER" && (
        <>
          {/* Cada modulo e um <div className="row"> proprio (em vez de um unico row
              pra tudo): assim a linha de Operacoes pode ter mais colunas por linha
              sem esticar/encolher os cards dos outros modulos, que tem 5. */}

          {/* Linha 1 - Modulo "Dados de cliente": cadastros de pessoas/entidades */}
          <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 row-cols-xl-5 g-4 mb-4">
            <Card cardName="client" iconName="person" route="/client" className="card-modulo-clientes" />
            <Card cardName="branch" iconName="people" route="/branch" className="card-modulo-clientes" />
            <Card cardName="warehouseClient" iconName="box-seam" route="/warehouseClient" className="card-modulo-clientes" />
            <Card cardName="supplier" iconName="person-vcard" route="/supplier" className="card-modulo-clientes" />
            <Card cardName="user" iconName="file-person" route="/user" className="card-modulo-clientes" />
          </div>

          {/* Linha 2 - Modulo "Cadastros CRUD": cadastros auxiliares */}
          <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 row-cols-xl-5 g-4 mb-4">
            <Card cardName="destination" iconName="truck" route="/destination" className="card-modulo-cadastros" />
            <Card cardName="warehouse" iconName="houses" route="/warehouse" className="card-modulo-cadastros" />
            <Card cardName="cargoDocumentType" iconName="file-earmark-text" route="/cargoDocumentType" className="card-modulo-cadastros" />
            <Card cardName="cargoSearchList" iconName="filter-square" route="/cargoSearchList" className="card-modulo-cadastros" />
            <Card cardName="warehouseUserClientReportDaily" iconName="table" route="/warehouseUserClientReportDaily" className="card-modulo-cadastros" />
          </div>

          {/* Linha 3 - Modulo "Operacoes": fluxo operacional de carga/liberacao - 9 cards
              (minhasCopias do lado de emailLog, mesmo tema; painelExecutivo e
              iniciativasEstrategicas do lado de report, tambem relacionados) - com
              tantos cards, quebra em mais de uma linha nas telas menores/medias, e
              tudo bem, nao vale forcar mais colunas so por causa disso. */}
          <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 row-cols-xl-6 g-4 mb-4">
            <Card cardName="cargoInfo" iconName="box" route="/cargo-info" className="card-modulo-operacoes" />
            <Card cardName="shipInfo" iconName="info-square" route="/shipinfo" className="card-modulo-operacoes" />
            <Card cardName="release" iconName="check2-square" route="/release" className="card-modulo-operacoes" />
            <Card cardName="emailLog" iconName="envelope-paper" route="/emailLog" className="card-modulo-operacoes" />
            <Card cardName="minhasCopias" iconName="envelope-paper" route="/carbon-copies" className="card-modulo-operacoes" />
            <Card cardName="systemLog" iconName="terminal" route="/systemLog" className="card-modulo-operacoes" />
            <Card cardName="report" iconName="graph-up" route="/report" className="card-modulo-operacoes" />
            <Card cardName="painelExecutivo" iconName="speedometer2" route="/painel-executivo" className="card-modulo-operacoes" />
            <Card cardName="iniciativasEstrategicas" iconName="compass" route="/iniciativas-estrategicas" className="card-modulo-operacoes" />
          </div>
        </>
      )}

      {userRole === "ROLE_ADMIN" && (
        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 row-cols-xl-5 g-4">
          <Card cardName="cargoInfo" iconName="box" route="/cargo-info" />
          <Card cardName="release" iconName="check2-square" route="/release" />
          <Card cardName="minhasCopias" iconName="envelope-paper" route="/carbon-copies" />
          <Card cardName="report" iconName="graph-up" route="/report" />
        </div>
      )}

      {userRole === "ROLE_USER" && (
        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 row-cols-xl-5 g-4">
          <Card cardName="cargoInfo" iconName="box" route="/cargo-info" />
          <Card cardName="minhasCopias" iconName="envelope-paper" route="/carbon-copies" />
        </div>
      )}

      {userRole === "ROLE_CLIENT" && (
        <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 row-cols-xl-5 g-4">
          <Card cardName="release" iconName="check2-square" route="/release" />
          <Card cardName="minhasCopias" iconName="envelope-paper" route="/carbon-copies" />
        </div>
      )}
    </div>
  );
};

export default Home;
